import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-tables',
  templateUrl: './ui-tables.component.html',
  styleUrls: ['./ui-tables.component.css']
})
export class UiTablesComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
